/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Audio_S2Inputs */

const en_tut_audio_s2 = /** @type {(inputs: Tut_Audio_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To speak, press **Nyalakan mikrofon** — a separate step, so listening never makes you audible.`)
};

const id_tut_audio_s2 = /** @type {(inputs: Tut_Audio_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau ingin bicara, tekan **Nyalakan mikrofon** — ini langkah terpisah, jadi mendengarkan saja tidak pernah membuat Anda terdengar.`)
};

/**
* | output |
* | --- |
* | "To speak, press **Nyalakan mikrofon** — a separate step, so listening never makes you audible." |
*
* @param {Tut_Audio_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_audio_s2 = /** @type {((inputs?: Tut_Audio_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Audio_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_audio_s2(inputs)
	return en_tut_audio_s2(inputs)
});